import {
  ApiClient,
  type ApiClientOptions,
  type CursorPagedResponse,
} from '@/infra/api-client'
import type {
  ListNotificationsRequest,
  NotificationRealtimeEventResource,
  NotificationResource,
  NotificationPreferencesResource,
  SetNotificationStatusRequest,
  UpdateNotificationPreferencesRequest,
} from './resources/notification'

export class NotificationApiRoot {
  readonly notifications
  readonly preferences

  constructor(options: ApiClientOptions) {
    this.notifications = new NotificationApi(options)
    this.preferences = new NotificationPreferencesApi(options)
  }
}

export class NotificationApi extends ApiClient {
  events$ = this._events<NotificationRealtimeEventResource>()

  list(
    request: ListNotificationsRequest,
    signal?: AbortSignal,
  ): Promise<CursorPagedResponse<NotificationResource>> {
    const params = ApiClient.createSearchParamsFromPageQuery(request)
    return this._get(`v3/notifications`, params, { signal })
  }

  batchChangeStatus(
    request: SetNotificationStatusRequest[],
    signal?: AbortSignal,
  ): Promise<NotificationResource[]> {
    return this._post('v3/notifications/status', request, undefined, { signal })
  }
}

export class NotificationPreferencesApi extends ApiClient {
  getPreferences(
    workspaceId: string,
    userId: string,
    signal?: AbortSignal,
  ): Promise<NotificationPreferencesResource> {
    return this._get(
      `v3/workspaces/${workspaceId}/members/${userId}/preferences`,
      undefined,
      { signal },
    )
  }

  updatePreferences(
    workspaceId: string,
    userId: string,
    payload: UpdateNotificationPreferencesRequest,
  ): Promise<NotificationPreferencesResource> {
    return this._patch(
      `v3/workspaces/${workspaceId}/members/${userId}/preferences`,
      payload,
    )
  }
}
